import { render, staticRenderFns } from "./EmployeeSwiftCodeField.vue?vue&type=template&id=be3c74aa&scoped=true&"
import script from "./EmployeeSwiftCodeField.vue?vue&type=script&lang=js&"
export * from "./EmployeeSwiftCodeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3c74aa",
  null
  
)

export default component.exports